export const REQUEST_STATEMENTS = "statements/REQUEST_STATEMENTS";
export const REQUEST_STATEMENTS_SUCCESS =
  "statements/REQUEST_STATEMENTS_SUCCESS";
export const REQUEST_STATEMENTS_FAIL = "statements/REQUEST_STATEMENTS_FAIL";

export const REQUEST_RELOAD_STATEMENTS = "statements/REQUEST_RELOAD_STATEMENTS";
export const REQUEST_RELOAD_STATEMENTS_SUCCESS =
  "statements/REQUEST_RELOAD_STATEMENTS_SUCCESS";
export const REQUEST_RELOAD_STATEMENTS_FAIL =
  "statements/REQUEST_RELOAD_STATEMENTS_FAIL";

export const REQUEST_STATEMENTS_ITEM = "statements/REQUEST_STATEMENTS_ITEM";
export const REQUEST_STATEMENTS_ITEM_SUCCESS =
  "statements/REQUEST_STATEMENTS_ITEM_SUCCESS";
export const REQUEST_STATEMENTS_ITEM_FAIL =
  "statements/REQUEST_STATEMENTS_ITEM_FAIL";

export const REQUEST_ADD_STATEMENTS = "statements/REQUEST_ADD_STATEMENTS";
export const REQUEST_ADD_STATEMENTS_SUCCESS =
  "statements/REQUEST_ADD_STATEMENTS_SUCCESS";
export const REQUEST_ADD_STATEMENTS_FAIL =
  "statements/REQUEST_ADD_STATEMENTS_FAIL";

export const REQUEST_DEL_STATEMENTS = "statements/REQUEST_DEL_STATEMENTS";
export const REQUEST_DEL_STATEMENTS_SUCCESS =
  "statements/REQUEST_DEL_STATEMENTS_SUCCESS";
export const REQUEST_DEL_STATEMENTS_FAIL =
  "statements/REQUEST_DEL_STATEMENTS_FAIL";

export const RESET_STATEMENTS_UPLOADS = "statements/RESET_STATEMENTS_UPLOADS";
export const UPDATE_STATEMENTS_PROGRESS =
  "statements/UPDATE_STATEMENTS_PROGRESS";

export const CLEAR_STATEMENTS_ERROR = "statements/CLEAR_STATEMENTS_ERROR";
